import React, {useEffect, useState} from 'react'
import "./index.scss"

import { format, subHours, startOfMonth } from 'date-fns';
import {
  MonthlyBody,
  MonthlyDay,
  MonthlyCalendar,
  MonthlyNav,
  DefaultMonthlyEventItem,
} from '@zach.codes/react-calendar';
import '@zach.codes/react-calendar/dist/calendar-tailwind.css';
import {useDispatch, useSelector} from 'react-redux'
import {fetchEvents} from '../../actions'





 const Calender = ()=>{

    const dispatch = useDispatch()
    const apiResponse = useSelector(state=>{
        const {events} = state
        const {event} = events
        return{
            event
        }
    })


    


   
    let [currentMonth, setCurrentMonth] = useState(
        startOfMonth(new Date())
      );
 
      var d = new Date();
      var yesterday = d.setDate(d.getDate() - 1);

      function toTimestamp(strDate){
        var datum = Date.parse(strDate);
        return datum/1000;
     }
     
      

      useEffect(()=>{
        dispatch(fetchEvents())
      },[])


      var formatEvents = []
      if(apiResponse.event && apiResponse.event?.length > 0){
          formatEvents = apiResponse.event.map(value=>{
              return{ title : value.description, date: new Date(value.eventDate).getTime()}
          })
      }

    const dummyData = [
        { title: '', date: subHours(new Date(), 2)},
        { title: '', date: yesterday },
    ]

    return (
        <div className="calender_wrapper">
            <div className="toolbar">
                <div className="toolbar-title">
                    <h2>Calender</h2>
                </div>
            </div>
            <div className="calender-container mt-4">
                <MonthlyCalendar
                        currentMonth={currentMonth}
                        onCurrentMonthChange={date => setCurrentMonth(date)}>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 10}}>
                            <MonthlyNav/>
                        </div>
                        <MonthlyBody
                            events={formatEvents.length > 0 ? formatEvents : dummyData}>
                            <MonthlyDay
                                renderDay={data =>
                                data.map((item, index) => (
                                <DefaultMonthlyEventItem
                                    key={index}
                                    title={item.title}
                                    // Format the date here to be in the format you prefer
                                    // date={format(item.date, 'k:mm')}
                                />
                                ))
                            }
                            />
                    </MonthlyBody>
                </MonthlyCalendar>
            </div>
        </div>
    )
}

export default Calender